import React, { useState, useRef, useEffect } from 'react';

import { ToolbarForm } from '../../utils/toolbar-form/ToolbarForm';


import { withLoadPanel } from '../../../utils/withLoadPanel';
import From, { Item as ItemForm, GroupItem, ColCountByScreen } from 'devextreme-react/form';
import SelectBox from 'devextreme-react/select-box';
import Button from 'devextreme-react/button';
import TextBox from 'devextreme-react/text-box';
import Validator, { PatternRule, EmailRule } from 'devextreme-react/validator';
import NumberBox from 'devextreme-react/number-box';
import { ATHLETE_STATUS_LIST, COMPETITION_STATUS_LIST, COURSES, GENDERS, TIMEKEEPING } from '../../../shared/constants';
import { FormPhoto } from '../../utils/form-photo/FormPhoto';
import { CompetitionStatus } from '../../utils/competition-status/CompetitionStatus';
import { FormTextbox } from '../../utils/form-textbox/FormTextbox';

import ValidationGroup from 'devextreme-react/validation-group';

import './CompetitionForm.scss';
import classNames from 'classnames';
import { DateBox } from 'devextreme-react';
import { FormDateBox } from '../../utils/form-datebox/FormDateBox';
import { FormSelectBox } from '../../utils/form-selectbox/FormSelectBox';
import { checkPermission } from '../../../permissions';

const PHOTO_SIZE = 184;

const statusRender = (text) => (
    <div className='status-editor-field'>
        <CompetitionStatus text={text} showText={false} />
        <TextBox
            className={`status-competition status-${text?.toLowerCase()}`}
            inputAttr={{ statusEditorInput: '' }}
            readOnly
            text={text}
            hoverStateEnabled={false}
        />
    </div>
);

const statusItemRender = (text) => <CompetitionStatus text={text} />;

export const CompetitionForm = ({ data, isLoading = false, onSave, isSmallScreen = false }) => {
    const [editing, setEditing] = useState(false);
    const [formData, setFormData] = useState(data.competition);
    const [dataSourceUser, setDataSourceUser] = useState();
    const dataRef = useRef();
    const stylingMode = 'filled';

    useEffect(() => {

        setFormData(data.competition);
        setDataSourceUser(data.users);
    }, [data]);

    const handleEditClick = () => {
        if (editing === false && formData) {
            dataRef.current = formData;
        } else {
            dataRef.current = undefined;
        }
        setEditing(!editing);
    };

    const onSaveClick = ({ validationGroup }) => {
        if (!validationGroup.validate().isValid) return;
        handleEditClick();
        onSave(formData);
    };

    const onCancelClick = () => {
        setFormData(dataRef.current);
        handleEditClick();
    };

    const updateField = (field) => (value) => {
        if (!formData) return;
        
        setFormData({ ...formData, ...{ [field]: value } });
    };

    return (
        <div className='competition-form'>
            <ValidationGroup>
                {!isSmallScreen && (
                    <ToolbarForm toggleEditing={handleEditClick} onSaveClick={onSaveClick} editing={editing} onCancelClick={onCancelClick} allowEditing={checkPermission("competition.edit")} />
                )}
                <From
                    className={classNames({ 'plain-styled-form': true, 'view-mode': !editing })}
                    labelMode='floating'
                    style={isSmallScreen ? { paddingTop: '20px', paddingLeft: '10px' } : {}}
                >
                    <GroupItem>
                     
                        <GroupItem caption="Wettkampfdetails" colCount={2}>
                        <ColCountByScreen xs={2} />
                            <ItemForm>
                                <SelectBox
                                    label='Status'
                                    width='100%'
                                    value={formData.status}
                                    readOnly={!editing}
                                    items={COMPETITION_STATUS_LIST}
                                    stylingMode={stylingMode}
                                    fieldRender={statusRender}
                                    itemRender={statusItemRender}
                                    onValueChange={updateField('status')}
                                />
                            </ItemForm>
                            <ItemForm>
                                <FormTextbox
                                    label='Wettkampfname'
                                    value={formData.competitionname}
                                    isEditing={!editing}
                                    onValueChange={updateField('competitionname')}
                                />
                            </ItemForm>
                            <ItemForm>
                                <FormTextbox
                                    label='Stadt'
                                    value={formData.city}
                                    isEditing={!editing}
                                    onValueChange={updateField('city')}
                                />
                            </ItemForm>
                            <ItemForm>
                                <FormTextbox
                                    label='Nation'
                                    value={formData.nation}
                                    isEditing={!editing}
                                    onValueChange={updateField('nation')}
                                />
                            </ItemForm>
                            <ItemForm>
                                <FormDateBox
                                    label='Startdatum'
                                    value={formData.startdate}
                                    readOnly={!editing}
                                    stylingMode={stylingMode}
                                    onValueChange={updateField('startdate')}
                                />
                            </ItemForm>
                            <ItemForm>
                                <FormDateBox
                                    label='Enddatum'
                                    value={formData.enddate}
                                    readOnly={!editing}
                                    stylingMode={stylingMode}
                                    onValueChange={updateField('enddate')}
                                />
                            </ItemForm>
                            <ItemForm>
                                <FormTextbox
                                    label='Gastgeberverein'
                                    value={formData.hostclub}
                                    isEditing={!editing}
                                    onValueChange={updateField('hostclub')}
                                />
                            </ItemForm>
                            <ItemForm>
                                <FormTextbox
                                    label='Veranstalter'
                                    value={formData.organizer}
                                    isEditing={!editing}
                                    onValueChange={updateField('organizer')}
                                />
                            </ItemForm>
                            <ItemForm>
                                <FormTextbox
                                    label='Ausschreibung'
                                    value={formData.invitation}
                                    isEditing={!editing}
                                    onValueChange={updateField('invitation')}
                                />
                            </ItemForm>
                            <ItemForm>
                                <FormSelectBox
                                    label='Bahnlänge'
                                    width='100%'
                                    value={formData.course}
                                    readOnly={!editing}
                                    dataSource={COURSES}
                                    valueExpr={'id'}
                                    displayExpr={'text'}
                                    onValueChange={updateField('course')}
                                />

                            </ItemForm>
                            <ItemForm>
                                <FormSelectBox
                                    label='Zeitmessung'
                                    width='100%'
                                    value={formData.timing}
                                    readOnly={!editing}
                                    dataSource={TIMEKEEPING}
                                    onValueChange={updateField('timing')}
                                />

                            </ItemForm>
                            <ItemForm>
                                <FormSelectBox
                                    label='Verantwortliche(r)'
                                    width='100%'
                                    value={formData.headUserId}
                                    readOnly={!editing}
                                    dataSource={dataSourceUser}
                                    valueExpr={'userId'}
                                    displayExpr={'displayName'}
                                    onValueChange={updateField('headUserId')}
                                />

                            </ItemForm>
                            <ItemForm>
                                <FormDateBox
                                    label='Meldeschluss'
                                    value={formData.deadline}
                                    readOnly={!editing}
                                    stylingMode={stylingMode}
                                    allowClear={false}
                                    onValueChange={updateField('deadline')}
                                />
                            </ItemForm>
                            <ItemForm>
                                <FormDateBox
                                    label='Interner Meldeschluss'
                                    value={formData.deadlineIntern}
                                    readOnly={!editing}
                                    stylingMode={stylingMode}
                                    allowClear={false}
                                    onValueChange={updateField('deadlineIntern')}
                                />
                            </ItemForm>
                            <ItemForm>
                                <FormTextbox
                                    label='Details'
                                    value={formData.details}
                                    isEditing={!editing}
                                    onValueChange={updateField('details')}
                                />
                            </ItemForm>
                        </GroupItem>
                        <GroupItem caption="Kontaktdetails" colCount={2}>
                        <ColCountByScreen xs={2} />
                            <ItemForm>
                                <FormTextbox
                                    label='Name'
                                    value={formData.contactName}
                                    isEditing={!editing}
                                    onValueChange={updateField('contactName')}
                                />
                            </ItemForm>
                            <ItemForm>
                                <FormTextbox
                                    label='E-Mail'
                                    value={formData.contactMail}
                                    isEditing={!editing}
                                    onValueChange={updateField('contactMail')}
                                />
                            </ItemForm>
                            <ItemForm>
                                <FormTextbox
                                    label='Telefon'
                                    value={formData.contactPhone}
                                    isEditing={!editing}
                                    onValueChange={updateField('contactPhone')}
                                />
                            </ItemForm>
                            <ItemForm>
                                <FormTextbox
                                    label='Straße'
                                    value={formData.contactStreet}
                                    isEditing={!editing}
                                    onValueChange={updateField('contactStreet')}
                                />
                            </ItemForm>
                            <ItemForm>
                                <FormTextbox
                                    label='PLZ'
                                    value={formData.contractPlz}
                                    isEditing={!editing}
                                    onValueChange={updateField('contractPlz')}
                                />
                            </ItemForm>
                            <ItemForm>
                                <FormTextbox
                                    label='Stadt'
                                    value={formData.contactCity}
                                    isEditing={!editing}
                                    onValueChange={updateField('contactCity')}
                                />
                            </ItemForm>
                            <ItemForm>
                                <FormTextbox
                                    label='IBAN'
                                    value={formData.contactIban}
                                    isEditing={!editing}
                                    onValueChange={updateField('contactIban')}
                                />
                            </ItemForm>
                            <ItemForm>
                                <FormTextbox
                                    label='BIC'
                                    value={formData.contactBic}
                                    isEditing={!editing}
                                    onValueChange={updateField('contactBic')}
                                />
                            </ItemForm>
                            <ItemForm>
                                <FormTextbox
                                    label='Bank'
                                    value={formData.contactBank}
                                    isEditing={!editing}
                                    onValueChange={updateField('contactBank')}
                                />
                            </ItemForm>
                            <ItemForm>
                                <FormTextbox
                                    label='Kontoinhaber'
                                    value={formData.contactAccountholder}
                                    isEditing={!editing}
                                    onValueChange={updateField('contactAccountholder')}
                                />
                            </ItemForm>


                        </GroupItem>
                        <GroupItem caption="Zusätzliche Informationen" colCount={2}>
                        <ColCountByScreen xs={2} />
                            <ItemForm>
                                <FormDateBox
                                    label='Qualizeitraum Beginn'
                                    value={formData.standardtimeStartdate}
                                    readOnly={!editing}
                                    stylingMode={stylingMode}
                                    allowClear={true}
                                    onValueChange={updateField('standardtimeStartdate')}
                                />
                            </ItemForm>
                            <ItemForm>
                                <FormDateBox
                                    label='Qualizeitraum Ende'
                                    value={formData.standardtimeEnddate}
                                    readOnly={!editing}
                                    stylingMode={stylingMode}
                                    allowClear={true}
                                    onValueChange={updateField('standardtimeEnddate')}
                                />
                            </ItemForm>
                             <ItemForm>
                                <FormSelectBox
                                    label='Qualizeitstyp'
                                    value={formData.standardtimeType}
                                    readOnly={!editing}
                                    stylingMode={stylingMode}
                                    allowClear={true}
                                    dataSource={['Pflichtzeit', 'Richtzeit']}
                                    onValueChange={updateField('standardtimeType')}
                                />
                            </ItemForm>

                        </GroupItem>


                    </GroupItem>


                </From>
            </ValidationGroup>
        </div>
    );
};
